export const footer = {
  time: "9:00-дан 21:00-ге дейін (демалыссыз)",
  phone: "+7 747 557 74 64",
  address_city: "Қазақстан, Алматы",
  address: "Желтоқсан көшесі 168а",
  faqs: "FAQs",
  list: "жабдықтар тізімі",
};
